import { API_BASE_URL } from "../../config";
import { createAuthenticatedClient } from "../../authenticatedClient";
import { safeValidate } from "../../safeValidate";
import { z } from "zod";
import {
  RoleResponse,
  roleResponseSchema,
  UserRoleAndPermissionResponse,
  userRoleAndPermissionSchema,
} from "../../schemas/roleSchema/role.schema";

const roleClient = createAuthenticatedClient(`${API_BASE_URL}/api/v1/rbac`);

export const roleApi = {
  getRoles: async (activeOnly = true): Promise<RoleResponse[]> => {
    const data = await roleClient.get<RoleResponse[]>(
      `/roles?activeOnly=${activeOnly}`,
    );
    return safeValidate(z.array(roleResponseSchema), data, "getRoles");
  },
  getCurrentUserRoles: async (): Promise<UserRoleAndPermissionResponse> => {
    const data =
      await roleClient.get<UserRoleAndPermissionResponse>(`/users/me/roles`);
    return safeValidate(
      userRoleAndPermissionSchema,
      data,
      "getCurrentUserRoles",
    );
  },
};
